import { addToChainAfter, addToChainBefore, ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetAccountShipToCollectionApiParameter } from "@insite/client-framework/Services/AccountService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/AccountShipTos/Handlers/LoadAccountShipToCollection";
import { AccountShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<GetAccountShipToCollectionApiParameter, AccountShipToCollectionModel>;

export const AddAssignedSortOrderToLoadShipTo: HandlerType = props => {
    props.apiParameter.sort = `Assign`
};

addToChainAfter(chain, PopulateApiParameter, AddAssignedSortOrderToLoadShipTo);